import { render, staticRenderFns } from "./OmcUpload.vue?vue&type=template&id=64fcb54e&scoped=true"
import script from "./OmcUpload.vue?vue&type=script&lang=js"
export * from "./OmcUpload.vue?vue&type=script&lang=js"
import style0 from "./OmcUpload.vue?vue&type=style&index=0&id=64fcb54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcb54e",
  null
  
)

export default component.exports